import * as angular from 'angular';
import { Component, Inject } from '@angular/core';
import { downgradeComponent } from '@angular/upgrade/static';
import { UIRouterState } from 'src/app/ajs-upgraded-providers';
import { PaymentService } from 'src/app/core/services/payment.service';

@Component({
  selector: 'payment-request',
  templateUrl: './payment-request.component.html',
  styleUrl: './payment-request.component.scss'
})
export class PaymentRequestComponent {
  public loading = true;
  public submitting = false;
  public allPaymentsPaid = false;
  // Set when the request cannot be loaded or paid. Every failure used to be
  // dropped except 409, which left the customer looking at a blank amount and
  // a Betalen button that did nothing when pressed.
  public failed = false;
  public paymentMethods: any;
  public amount: any;

  constructor(
    @Inject(UIRouterState) private $state,
    private paymentService: PaymentService) {

  }

  public ngOnInit(): void {
    this.paymentService.getRetryPayment(this.$state.params.paymentPlanExternalReference)
      .subscribe((response) => {
        this.amount = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(response.amount);
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.handleError(error);
      });

    this.paymentService.getMethods(this.getCountry())
      .subscribe((result) => {
        this.paymentMethods = result;
      });
  }

  private getCountry = () => {
    if (window.location.hostname.endsWith('.be')) {
      return "BE";
    } else {
      return "NL";
    }
  };

  private handleError = (error) => {
    if (error.status === 409) {
      this.allPaymentsPaid = true;
    } else {
      console.error(error);
      this.failed = true;
    }
  };

  public submitPayment = () => {
    if (this.submitting) {
      return;
    }
    this.submitting = true;
    this.paymentService.submitRetryPayment(this.$state.params.paymentPlanExternalReference)
      .subscribe((response) => {
        window.location.href = response.checkoutUrl;
      },
      (error) => {
        this.submitting = false;
        this.handleError(error);
      });
  }

}

angular.
  module('paymentRequest', [])
    .directive('paymentRequest', downgradeComponent({component: PaymentRequestComponent}) as angular.IDirectiveFactory);
